module.exports = __webpack_public_path__ + "img/hotel.9e0ccae5.svg";